import React, { useEffect, useState } from 'react';
import PaymentModeListing from './PaymentModeListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setIsOpenAddDialog, setIsOpenEditDialog, setPage, setRowsPerPage, setSearchValue, setIsTableLoading, setItems, setTotalItems } from 'src/redux/slices/PaymentModeSlice';
import AddPaymentModeWrapper from '../Add/AddPaymentModeWrapper';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import EditPaymentModeWrapper from '../Edit/EditPaymentModeWrapper';
import { useChangeStatusPaymentModeByIdMutation, useDeletePaymentModeByIdMutation, useGetAllPaymentModeDataQuery } from 'src/services/PaymentModeService';
import { usePermission } from 'src/hooks/usePermission';
import { Tooltip } from '@mui/material';

type Props = {};

const PaymentModeListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, isOpenAddDialog, isOpenEditDialog, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.paymentMode);
  const [selectedPaymentModeId, setSelectedPaymentModeId] = useState<string>()
  const [deletePaymentMode] = useDeletePaymentModeByIdMutation()
  const [changeStatusPaymentMode] = useChangeStatusPaymentModeByIdMutation()
  const { data, isLoading, isFetching } = useGetAllPaymentModeDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: [
      "name",

    ],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const handleDeletePaymentMode = (row: string) => {
    showConfirmationDialog({
      title: "Hands Up",
      text: "Are you sure want to delete this Payment Mode ?",
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          deletePaymentMode(row).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

  const handleChangeStatusPaymentMode = (row: any) => {
    const actionLabel = row?.isActive ? "deactive" : "active";
    showConfirmationDialog({
      title: "Hands Up",
      text: `Are you sure want to ${actionLabel} this Payment Mode ?`,
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          changeStatusPaymentMode({ id: row?._id }).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

const moduleName = "PAYMENT_MODE";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

const columns: columnTypes[] = [
  { field: 'type', headerName: 'Payment type', flex: 'flex-[1_1_0%]', renderCell: (row: any) => (
        <Tooltip title={row?.type || "-"}>
          <div className="text-[13px]">
            {row?.type
              ? row.type.charAt(0).toUpperCase() +
                row.type.slice(1).toLowerCase()
              : "-"}
          </div>
        </Tooltip>
      ), },
  { field: 'name', headerName: 'Currency Name', flex: 'flex-[1_1_0%]' },
  { field: 'value', headerName: 'Currency value', flex: 'flex-[1_1_0%]' },

  {
    field: "action",
    headerName: "Actions",
    flex: "flex-[1_1_0%]",
    extraClasses: "",
    renderCell: (row: any) => {
      const options = [];

      if (canEdit) {
        options.push({
          label: "Edit",
          onClick: () => {
            dispatch(setIsOpenEditDialog(true));
            setSelectedPaymentModeId(row?._id);
          },
        });
      }

      if (canActive) {
        options.push({
          label: row?.isActive ? "Deactive" : "Active",
          onClick: () => {
            handleChangeStatusPaymentMode(row);
          },
        });
      }

      if (canDelete) {
        options.push({
          label: "Delete",
          onClick: () => {
            handleDeletePaymentMode(row?._id);
          },
        });
      }

      return <ATMMenu options={options} />;
    },
  },
];


  return (
    <>
      <div>
        <PaymentModeListing
          columns={columns}
          rows={ items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {isOpenAddDialog ? (
        <AddPaymentModeWrapper
          onClose={() => dispatch(setIsOpenAddDialog(false))}
        />
      ) : null}
      {isOpenEditDialog ? (
        <EditPaymentModeWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedPaymentModeId={selectedPaymentModeId || ""}

        />
      ) : null}
    </>
  );
};

export default PaymentModeListingWrapper;